import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, setAuthError } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = window.location.hash.split("session_id=")[1];
    if (!sessionId) {
      navigate("/login");
      return;
    }

    api
      .post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } })
      .then((res) => {
        setUser(res.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { state: { user: res.data } });
      })
      .catch((e) => {
        const message =
          e.response?.status === 403
            ? e.response.data?.detail
            : "Connexion impossible. Merci de réessayer.";
        setError(message);
        setAuthError(message);
        setTimeout(() => navigate("/login"), 3000);
      });
  }, [navigate, setUser, setAuthError]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback-loading">
      <div className="text-center space-y-3">
        <div className="h-8 w-8 mx-auto border-2 border-primary border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-muted-foreground">{error || "Connexion en cours..."}</p>
      </div>
    </div>
  );
}
